import React, { useContext, useReducer } from 'react'
import { UPDATE_APP_STATE, UPDATE_SPECIFIC_STATE } from '../helpers/dispatch_actions'

const initialState = {
  footer: { hidden: false },
}

const stateReducer = (state, { type, data, key }) => {
  const change = { ...state }
  switch (type) {
    case UPDATE_APP_STATE:
      return { ...change, ...data }
    case UPDATE_SPECIFIC_STATE:
      change[key] = data
      break
    default:
      return change
  }
  return change
}

const AppContext = React.createContext()
const AppUpdateContext = React.createContext()

export const useAppState = () => {
  return useContext(AppContext)
}

export const useAppDispatch = () => {
  return useContext(AppUpdateContext)
}

export default function AppRootProvider({ children }) {
  const [appState, setAppState] = useReducer(stateReducer, initialState)

  return (
    <AppContext.Provider value={appState}>
      <AppUpdateContext.Provider value={setAppState}>{children}</AppUpdateContext.Provider>
    </AppContext.Provider>
  )
}
